import { queryClient } from 'index';
import { useTranslation } from 'react-i18next';
import { useMutation, useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { getToastErrorMessage, LogyxError } from 'services/api/errors';
import { ReactMutationKeys } from 'services/api/reactMutationKeys';
import { ReactQueryKeys } from 'services/api/reactQueryKeys';
import { deleteCompanyUser, getUsers } from 'services/CompanyService';

export const useGetUsers = (page: number, perPage: number, searchBy: string) =>
  useQuery({
    queryKey: [ReactQueryKeys.GET_USERS, page, perPage, searchBy],
    queryFn: () => {
      return getUsers(page, perPage, searchBy);
    },
  });

export const useDeleteCompanyUser = () => {
  const { t } = useTranslation();
  return useMutation((userId: number) => deleteCompanyUser(userId), {
    onError: (error: LogyxError) => {
      toast.error(getToastErrorMessage(error));
    },
    onSuccess: () => {
      toast.success(t('Removed user from company'));
      queryClient.invalidateQueries([ReactQueryKeys.GET_USERS]);
    },
    mutationKey: ReactMutationKeys.DELETE_COMPANY_USER,
  });
};
